import React, { ForwardedRef, type JSX } from 'react'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | JSX.Element
  classes?: string
  forwardRef?: ForwardedRef<HTMLInputElement>
  ['data-test-id']?: string
}

const Checkbox = ({
  id,
  name,
  forwardRef,
  value,
  classes,
  checked,
  disabled,
  onChange,
  readOnly,
  onKeyDown,
  ['data-test-id']: dataTestId,
}: CheckboxProps) => (
  <input
    id={id}
    className={classes}
    type="checkbox"
    name={name}
    ref={forwardRef}
    value={value}
    checked={checked}
    disabled={disabled}
    onChange={onChange}
    data-test-id={dataTestId}
    readOnly={readOnly}
    onKeyDown={onKeyDown}
  />
)

export default Checkbox
